// A production build sets VITE_GAZE_WASM_URL to the copy of the wasm with a content hash in its
// name (see vite/hashGazeFiles.ts). The dev server serves the file from `public/gaze/`.
export const GAZE_WASM_URL: string =
  import.meta.env.VITE_GAZE_WASM_URL ?? "/gaze/gaze_bg.wasm";
